<agr-wrapper-site-sidenav [logoSvgIcon]="logoSvgIcon" data-test="site-root">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
